import AddUserPlanModal from './container'

export default AddUserPlanModal
